import { render, staticRenderFns } from "./WannasornMemberCreateForm.vue?vue&type=template&id=68b33034&scoped=true"
import script from "./WannasornMemberCreateForm.vue?vue&type=script&lang=js"
export * from "./WannasornMemberCreateForm.vue?vue&type=script&lang=js"
import style0 from "./WannasornMemberCreateForm.vue?vue&type=style&index=0&id=68b33034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b33034",
  null
  
)

export default component.exports